import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function EmotionalClose() {
  return <section className="py-8 md:py-10 px-4 bg-white text-center relative" data-id="element-25">
      {/* Decorative top divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-px bg-dusty-rose-300" data-id="element-26"></div>

      <div className="max-w-2xl mx-auto" data-id="element-27">
        <FadeIn data-id="element-28">
          <div className="space-y-4 md:space-y-6 text-lg md:text-2xl text-burgundy-900 font-heading leading-relaxed" data-id="element-29">
            <p data-id="element-30">Tu hijo no vino con manual.</p>
            <p data-id="element-31">Pero hoy podés tenerlo.</p>
            <p className="italic" data-id="element-32">
              Por once dólares podés dejar de adivinar y empezar a criar con la
              calma, la claridad y la conexión que los dos se merecen.
            </p>
          </div>

          <div className="mt-10 md:mt-16" data-id="element-33">
            <p className="font-heading italic text-base md:text-lg text-burgundy-700" data-id="element-34">
              Con amor y propósito,
            </p>
            <p className="font-bold text-burgundy-900 mt-2" data-id="element-35">
              El equipo de Código Hijo
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}